module.exports = __webpack_public_path__ + "img/hr-red-pita-05.74b813b5.png";